import type { DashboardGridItem, DashboardWidgetType } from './dashboard-widget-types';
import { DASHBOARD_WIDGET_REGISTRY } from './dashboard-widgets.registry';

function isWidgetType(t: string): t is DashboardWidgetType {
  return t in DASHBOARD_WIDGET_REGISTRY;
}

/**
 * localStorage / merges pueden dejar rows/cols como undefined → gridster usa defaultItemRows=1 → celdas ~30px.
 */
export function sanitizeDashboardGridItems(raw: unknown): DashboardGridItem[] {
  if (!Array.isArray(raw)) return [];
  const out: DashboardGridItem[] = [];
  for (const entry of raw) {
    if (!entry || typeof entry !== 'object') continue;
    const o = entry as Record<string, unknown>;
    const id = o['id'];
    const wt = o['widgetType'];
    if (typeof id !== 'string' || typeof wt !== 'string' || !isWidgetType(wt)) continue;
    const meta = DASHBOARD_WIDGET_REGISTRY[wt];
    const cols = Math.min(12, Math.max(meta.minCols ?? 2, Number(o['cols']) || meta.defaultCols));
    const rows = Math.max(meta.minRows ?? 2, Number(o['rows']) || meta.defaultRows);
    out.push({
      id,
      widgetType: wt,
      x: Math.max(0, Number(o['x']) || 0),
      y: Math.max(0, Number(o['y']) || 0),
      cols,
      rows,
      minItemCols: meta.minCols,
      minItemRows: meta.minRows
    });
  }
  return out;
}
